import React from "react";
import PropTypes from "prop-types";
import { Message, Container, Table } from "semantic-ui-react";
import RecommendationRow from "./recommendation-row";

const RecommendationTable = ({
  recommendations = [],
  loadingData,
  handleSort,
  sortColumn,
  sortDirection,
  activeFilterPrimary,
  activeFilterSecondary,
  dotNotation,
  dotNotationExists
}) => {
  const haveRecommendations = recommendations.length > 0;

  // Convert sortDirection for aria-sort
  const getAriaSort = columnName => {
    if (sortColumn !== columnName) return "none";
    return sortDirection === "ascending" ? "ascending" : "descending";
  };

  // Handle keyboard events for sorting
  const handleKeyDown = (e, columnName) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleSort(columnName);
    }
  };
  return (
    <Container className="recommendations-table">
      <Table
        sortable
        celled
        stackable
        selectable={haveRecommendations}
        size="small"
        aria-label="Recommendation List - sortable table"
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={sortColumn === "auditName" ? sortDirection : null}
              onClick={() => handleSort("auditName")}
              tabIndex={0}
              aria-sort={getAriaSort("auditName")}
              onKeyDown={e => handleKeyDown(e, "auditName")}
              aria-label="Sort by Audit and Finding"
            >
              Audit & Finding
            </Table.HeaderCell>
            {dotNotationExists && (
              <Table.HeaderCell
                sorted={
                  sortColumn === "recommendationNumber" ? sortDirection : null
                }
                onClick={() => handleSort("recommendationNumber")}
                tabIndex={0}
                aria-sort={getAriaSort("recommendationNumber")}
                onKeyDown={e => handleKeyDown(e, "recommendationNumber")}
                aria-label="Sort by recommendation number"
              >
                #
              </Table.HeaderCell>
            )}
            <Table.HeaderCell
              sorted={
                sortColumn === "recommendationText" ? sortDirection : null
              }
              onClick={() => handleSort("recommendationText")}
              tabIndex={0}
              aria-sort={getAriaSort("recommendationText")}
              onKeyDown={e => handleKeyDown(e, "recommendationText")}
              aria-label="Sort by Recommendation text"
            >
              Recommendation
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "update" ? sortDirection : null}
              onClick={() => handleSort("update")}
              tabIndex={0}
              aria-sort={getAriaSort("update")}
              onKeyDown={e => handleKeyDown(e, "update")}
              aria-label="Sort by Last Update"
            >
              Last Update
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "status" ? sortDirection : null}
              onClick={() => handleSort("status")}
              tabIndex={0}
              aria-sort={getAriaSort("status")}
              onKeyDown={e => handleKeyDown(e, "status")}
              aria-label="Sort by Status"
            >
              Status
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "issueDate" ? sortDirection : null}
              onClick={() => handleSort("issueDate")}
              tabIndex={0}
              aria-sort={getAriaSort("issueDate")}
              onKeyDown={e => handleKeyDown(e, "issueDate")}
              aria-label="Sort by Issue Date"
            >
              Issue Date
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "department" ? sortDirection : null}
              onClick={() => handleSort("department")}
              tabIndex={0}
              aria-sort={getAriaSort("department")}
              onKeyDown={e => handleKeyDown(e, "department")}
              aria-label="Sort by Department"
            >
              Department
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "category" ? sortDirection : null}
              onClick={() => handleSort("category")}
              tabIndex={0}
              aria-sort={getAriaSort("category")}
              onKeyDown={e => handleKeyDown(e, "category")}
              aria-label="Sort by Category"
            >
              Category
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {recommendations.map(recommendation => (
            <RecommendationRow
              key={recommendation.recommendationId}
              {...{
                recommendation,
                activeFilterPrimary,
                activeFilterSecondary,
                dotNotation,
                dotNotationExists
              }}
            />
          ))}
          {!haveRecommendations && !loadingData && (
            <Table.Row>
              <Table.Cell colSpan={8}>
                <Message info content="No recommendations found!" />
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </Container>
  );
};

RecommendationTable.propTypes = {
  recommendations: PropTypes.arrayOf(
    PropTypes.shape({
      recommendationId: PropTypes.string.isRequired
    })
  ).isRequired,
  loadingData: PropTypes.bool.isRequired,
  handleSort: PropTypes.func.isRequired,
  sortColumn: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  activeFilterPrimary: PropTypes.string,
  activeFilterSecondary: PropTypes.string,
  dotNotation: PropTypes.bool,
  dotNotationExists: PropTypes.bool.isRequired
};

RecommendationTable.defaultProps = {
  activeFilterPrimary: null,
  activeFilterSecondary: null,
  dotNotation: false
};

export default RecommendationTable;
